import { Button, Flex, Input, List, Typography } from "antd";
import theme from "../../../theme";
import { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { Text } = Typography;

const allCountries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas",
  "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin",
  "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei",
  "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon",
  "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia",
  "Comoros", "Congo (Congo-Brazzaville)", "Costa Rica", "Croatia", "Cuba", "Cyprus",
  "Czech Republic", "Democratic Republic of the Congo", "Denmark", "Djibouti",
  "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
  "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji",
  "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece",
  "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti",
  "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland",
  "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan",
  "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon",
  "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands",
  "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia",
  "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal",
  "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea",
  "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine State",
  "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland",
  "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis",
  "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles",
  "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
  "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan",
  "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
  "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia",
  "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
  "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City",
  "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

const CountryListItem = (props: {
  item: string;
  isSelected: boolean;
  onClick: (item: string) => void;
}) => (
  <List.Item
    onClick={() => props.onClick(props.item)}
    style={{
      backgroundColor: props.isSelected ? theme.token?.colorPrimary : "white",
      color: props.isSelected ? "white" : "black",
      cursor: "pointer",
      paddingLeft: 16,
      paddingRight: 16,
    }}
  >
    {props.item}
  </List.Item>
);

interface CountryEditorProps {
  countries: string[];
  setCountries: (countries: string[]) => void;
}

export default function CountryEditor(props: CountryEditorProps) {
  const [selCountries, setSelCountries] = useState<string[]>([]);
  const [selProdCountries, setSelProdCountries] = useState<string[]>([]);
  const [search, setSearch] = useState<string>("");

  function handleSelect(item: string) {
    if (selCountries.find(x => x === item) !== undefined) {
      setSelCountries(selCountries.filter(x => x !== item));
    } else {
      setSelCountries([...selCountries, item]);
    }
  }

  function handleSelectProductCountries(item: string) {
    if (selProdCountries.find(x => x === item) !== undefined) {
      setSelProdCountries(selProdCountries.filter(x => x !== item));
    } else {
      setSelProdCountries([...selProdCountries, item]);
    }
  }

  function handleAddSelToProd() {
    const newCountries = [...props.countries, ...selCountries];
    setSelCountries([]);
    props.setCountries(newCountries);
  }

  function handleRemoveSelFromProd() {
    const newCountries = props.countries.filter(
      x => selProdCountries.find(y => y === x) === undefined
    );
    setSelProdCountries([]);
    props.setCountries(newCountries);
  }

  const availableCountries = allCountries.filter(
    c1 => ((props.countries ?? []).find(c2 => c1 === c2) === undefined)
          && (search.length > 0
            ? c1.toLowerCase().includes(search.toLowerCase())
            : true)
  );

  return (<>
    <Input
      addonBefore="Search"
      value={search}
      onChange={e => setSearch(e.target.value)}
    />
    <Flex gap={16}>
      <List
        pagination={{
          position: "bottom",
          align: "center",
          pageSize: 5,
          simple: true,
          showSizeChanger: false,
          hideOnSinglePage: true
        }}
        dataSource={availableCountries}
        header={<Text type="secondary">Available Countries</Text>}
        renderItem={item =>
          <CountryListItem
            item={item}
            isSelected={selCountries.find(x => x === item) !== undefined}
            onClick={handleSelect}
          />
        }
        style={{ flex: 1, height: "100%" }}
      />
      <Flex vertical justify="center" align="center" gap={8}>
        <Button icon={<RightOutlined />} onClick={handleAddSelToProd} />
        <Button icon={<LeftOutlined />} onClick={handleRemoveSelFromProd} />
      </Flex>
      <List
        pagination={{
          position: "bottom",
          pageSize: 5,
          align: "center",
          simple: true,
          showSizeChanger: false,
          hideOnSinglePage: true
        }}
        dataSource={props.countries}
        header={<Text type="secondary">Product Countries</Text>}
        renderItem={item =>
          <CountryListItem
            item={item}
            isSelected={selProdCountries.find(x => x === item) !== undefined}
            onClick={handleSelectProductCountries}
          />
        }
        style={{ flex: 1, height: "100%" }}
      />
    </Flex>
  </>)
}